module.exports = __webpack_public_path__ + "img/3f_r_first.73600184.jpg";